import React from "react";
import { StyleSheet, TextStyle, View } from "react-native";
import { kStyleConst } from "src/kStyle";
import { CheckMark2 } from "./NewCheckBox2";

type tYesNo = {
  myState?: boolean;
  onPressTrue: () => void;
  onPressFalse: () => void;
  myText: [string, string];
  myLeaveSpace?: boolean;
  textStyle?: TextStyle;
};

type tpYesNo = (props: tYesNo) => React.ReactElement;

export const YesNo: tpYesNo = ({ myState, onPressFalse, onPressTrue, myText, textStyle }) => {
  return (
    <View style={styles.gCheckMark2BoxContainer}>
      <CheckMark2
        myText={myText[0]}
        myState={myState === false}
        onPress={onPressFalse}
        myLeaveSpace={true}
        textPlacement="left"
        textStyle={textStyle}
      />
      <CheckMark2
        myText={myText[1]}
        myState={myState}
        onPress={onPressTrue}
        textPlacement="left"
        textStyle={textStyle}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  gCheckMark2BoxContainer: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: 2 * kStyleConst.kSpacing,
  },
});
